import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { ProductCategoryProvider } from "../../providers/product-category/product-category";
import { ProductCategory } from "../../models/product-category.model";

import { LoginPage } from '../auth/login';
import { ProductsPage } from '../products/products';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { listAnimation } from '../../animations/list-animation';

@IonicPage()
@Component({
  selector: 'page-product-categories',
  templateUrl: 'product-categories.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class ProductCategoriesPage {

  brandID: number;

  productCategories: ProductCategory[];

  loading: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public productCategoryProvider: ProductCategoryProvider) {}

  getProductCategories() {
    this.loading = true;
    this.productCategoryProvider.getAll()
      .subscribe(
        productCategories => this.productCategories = productCategories,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  reloadProductCategories(refresher) {
    this.productCategoryProvider.getAll()
      .subscribe(
        productCategories => {
          this.productCategories = productCategories
        },
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          refresher.complete();
        },
        () => {
          refresher.complete();
        }
      );
  }

  selectProductCategory(category: ProductCategory) {
    this.navCtrl.push(ProductsPage, {
      productCategoryID: category.id,
      productCategoryName: category.translation || category.name
    });
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getProductCategories();
  }

}



// WEBPACK FOOTER //
// ./src/pages/product-categories/product-categories.ts